
/* BOOBEES clean merchandising: keep native Shopify variant picker as checkout source of truth. */
(function () {
  'use strict';

  function closeNav(from) {
    var drawer = from.closest('details[data-bb-nav]');
    if (drawer) drawer.open = false;
  }
  function updateCardSwatch(btn) {
    var card = btn.closest('[data-bb-shade-card]');
    if (!card || btn.disabled) return;
    card.querySelectorAll('[data-bb-shade-button]').forEach(function (b) {
      var selected = b === btn;
      b.classList.toggle('is-selected', selected);
      b.setAttribute('aria-pressed', String(selected));
    });
    var title = card.querySelector('[data-bb-current-shade]');
    if (title) title.textContent = btn.dataset.bbColor;
    card.dataset.bbCurrentShade = btn.dataset.bbColor;
    var photo = card.querySelector('.bb-shade-card__image');
    if (photo && btn.dataset.bbImage) {
      photo.removeAttribute('srcset');
      photo.removeAttribute('sizes');
      photo.setAttribute('src', btn.dataset.bbImage);
      photo.setAttribute('alt', btn.dataset.bbImageAlt);
    }
    card.querySelectorAll('[data-bb-card-link]').forEach(function(link) {
      if(btn.dataset.bbVariantLink) link.href=btn.dataset.bbVariantLink;
    });
  }
  function displayGalleryIndex(gallery, rawIndex) {
    if (!gallery) return;
    var slides = Array.from(gallery.querySelectorAll('[data-bb-gallery-slide]'));
    if (!slides.length) return;
    var index = ((rawIndex % slides.length) + slides.length) % slides.length;
    slides.forEach(function (slide) {
      slide.hidden = Number(slide.dataset.bbGallerySlide) !== index;
    });
    gallery.querySelectorAll('[data-bb-thumb-index]').forEach(function(button) {
      var selected = Number(button.dataset.bbThumbIndex) === index;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    var counter = gallery.querySelector('[data-bb-gallery-position]');
    if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
  }
  function updateSizeCards(root, size) {
    root.querySelectorAll('[data-bb-size-choice]').forEach(function (card) {
      var active = card.dataset.bbSizeChoice === size;
      card.classList.toggle('is-selected', active);
      card.setAttribute('aria-pressed', String(active));
    });
  }
  document.addEventListener('click', function (event) {
    var shadeButton = event.target.closest('[data-bb-shade-button]');
    if (shadeButton) { updateCardSwatch(shadeButton); return; }
    var closeButton = event.target.closest('[data-bb-nav-close]');
    if (closeButton) { closeNav(closeButton); return; }
    var card = event.target.closest('[data-bb-size-choice]');
    if (card) {
      var section = card.closest('.shopify-section') || document;
      var picker = section.querySelector('variant-picker[data-boobees-shade-filter="true"]');
      if (!picker) return;
      var size = card.dataset.bbSizeChoice;
      var radio = Array.from(picker.querySelectorAll('input[name^="Size-"]')).find(function (el) { return el.value === size; });
      var select = picker.querySelector('select[name="options[Size]"]');
      if (radio && !radio.checked) radio.click();
      else if (select && select.value !== size) {
        select.value = size;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      updateSizeCards(section, size);
      return;
    }
    var thumb = event.target.closest('[data-bb-thumb-index]');
    if (thumb) { displayGalleryIndex(thumb.closest('[data-boobees-filtered-gallery]'), Number(thumb.dataset.bbThumbIndex)); return; }
    var arrow = event.target.closest('[data-bb-gallery-prev], [data-bb-gallery-next]');
    if (arrow) {
      var gallery = arrow.closest('[data-boobees-filtered-gallery]');
      if (!gallery) return;
      var selected = gallery.querySelector('.bb-filtered-gallery__thumb.is-active');
      var index = selected ? Number(selected.dataset.bbThumbIndex) : 0;
      displayGalleryIndex(gallery, index + (arrow.hasAttribute('data-bb-gallery-next') ? 1 : -1));
      return;
    }
  });
  var swipeStart = null;
  document.addEventListener('touchstart', function (event) {
    var target = event.target.closest('[data-bb-gallery-touch]');
    if (!target || !event.touches.length) return;
    swipeStart = { target: target, x: event.touches[0].clientX, y: event.touches[0].clientY };
  }, { passive: true });
  document.addEventListener('touchend', function (event) {
    if (!swipeStart || !event.changedTouches.length) return;
    var dx = event.changedTouches[0].clientX - swipeStart.x;
    var dy = event.changedTouches[0].clientY - swipeStart.y;
    var target = swipeStart.target;
    swipeStart = null;
    if (Math.abs(dx) < 42 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
    var gallery = target.closest('[data-boobees-filtered-gallery]');
    if (!gallery) return;
    var selected = gallery.querySelector('.bb-filtered-gallery__thumb.is-active');
    var index = selected ? Number(selected.dataset.bbThumbIndex) : 0;
    displayGalleryIndex(gallery, index + (dx < 0 ? 1 : -1));
  }, { passive: true });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') document.querySelectorAll('details[data-bb-nav][open]').forEach(function(drawer){drawer.open=false;});
  });
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target && ((target.name && target.name.startsWith('Size-')) || target.name === 'options[Size]')) {
      var section = target.closest('.shopify-section') || document;
      updateSizeCards(section, target.value);
    }
  });
})();
